<div class="driver-manager d-flex gap-4 flex-column" *transloco="let t; prefix: 'driverManager'">
  <div class="row align-content-center driver-manager__header">
    <div class="col-lg-5 align-self-center">
      <h2 class="m-0 h3">{{ t('title') }}</h2>
    </div>
    <div class="col-lg-7">
      <div class="row gx-3 justify-content-end">
        @if (expandedComponentId == null) {
          <div class="col-md-12 col-lg-6 px-0">
            <app-account-filter [filter]="accountFilter" class="w-100 py-2 px-0"
              (filterChanged)="onAccountFilterChange($event)">
            </app-account-filter>
          </div>
        }
        @if (expandedComponentId !== null) {
          <div class="col-md-12 col-lg-5 px-0">
            <div class="input-group">
              <input [placeholder]="t('searchPlaceholder')" type="search" class="form-control dropdown-toggle search-input"
                [(ngModel)]="searchTerm" (ngModelChange)="searchSubject.next($event)">
                <span class="input-group-text bg-transparent">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M6.66927 11.9997C7.89994 11.9997 9.03127 11.5763 9.93394 10.8743L12.8646 13.805L13.8073 12.8623L10.8766 9.93167C11.5793 9.02834 12.0026 7.89701 12.0026 6.66634C12.0026 3.72567 9.60994 1.33301 6.66927 1.33301C3.7286 1.33301 1.33594 3.72567 1.33594 6.66634C1.33594 9.60701 3.7286 11.9997 6.66927 11.9997ZM6.66927 2.66634C8.87527 2.66634 10.6693 4.46034 10.6693 6.66634C10.6693 8.87234 8.87527 10.6663 6.66927 10.6663C4.46327 10.6663 2.66927 8.87234 2.66927 6.66634C2.66927 4.46034 4.46327 2.66634 6.66927 2.66634Z"
                      fill="#6B6D71" />
                    </svg>
                  </span>
                </div>
              </div>
            }
            <div class="w-auto">
              <button class="btn btn-primary btn--add-drivers h-100 text-center"
              [routerLink]="['/driver-management/driver-manager/settings']">{{ t('settingsButton') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="driver-manager__cards" [ngClass]="{ 'driver-manager__cards--expanded': expandedComponentId !== null }">
        <div class="driver-manager__card"
          [ngClass]="{ 'driver-manager__card--expanded': expandedComponentId === 'yard', 'driver-manager__card--hidden': expandedComponentId && expandedComponentId !== 'yard' }">
          <app-drivers-in-yard-modal [isModal]="false" [componentId]="'yard'" (toggleExpandEvent)="onToggleExpand($event)"
          [search$]="getSearchObservable('yard')"></app-drivers-in-yard-modal>
        </div>

        <div class="driver-manager__card"
          [ngClass]="{ 'driver-manager__card--expanded': expandedComponentId === 'vehicle', 'driver-manager__card--hidden': expandedComponentId && expandedComponentId !== 'vehicle' }">
          <app-drivers-in-vehicle-modal [isModal]="false" [componentId]="'vehicle'"
            (toggleExpandEvent)="onToggleExpand($event)"
          [search$]="getSearchObservable('vehicle')"></app-drivers-in-vehicle-modal>
        </div>

        <div class="driver-manager__card"
          [ngClass]="{ 'driver-manager__card--expanded': expandedComponentId === 'enRoute', 'driver-manager__card--hidden': expandedComponentId && expandedComponentId !== 'enRoute' }">
          <app-drivers-en-route-modal [isModal]="false" [componentId]="'enRoute'" [search$]="getSearchObservable('enRoute')"
            (toggleExpandEvent)="onToggleExpand($event)">
          </app-drivers-en-route-modal>
        </div>

        <div class="driver-manager__card"
          [ngClass]="{ 'driver-manager__card--expanded': expandedComponentId === 'stationary', 'driver-manager__card--hidden': expandedComponentId && expandedComponentId !== 'stationary' }">
          <app-stationary-drivers-modal [isModal]="false" [componentId]="'stationary'"
            [search$]="getSearchObservable('stationary')" (toggleExpandEvent)="onToggleExpand($event)">
          </app-stationary-drivers-modal>
        </div>
      </div>
    </div>